import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AppText from "../../../UI/Texts/AppTexts";

export function JobUnavailable({ job, hasSimilarJobs = false }) {
  const { t, i18n } = useTranslation();
  const coreConstants = useSelector((state) => state.core.constants);
  const language = (i18n.resolvedLanguage ?? i18n.language ?? "sv").split(
    "-",
  )[0];

  const profession = (() => {
    const roles = coreConstants?.workroles ?? [];
    const translatedRole = roles.find((role) => role.id === job?.profession)
      ?.text?.[language];

    return translatedRole || job?.profession || "";
  })();

  const healthcareWorkplace =
    job?.healthcareWorkplaceDetails ?? job?.workplaceDetails ?? {};
  const healthcareWorkplaceName =
    healthcareWorkplace.name ??
    healthcareWorkplace.name_obj ??
    job?.workplaceDetails?.name ??
    "";
  const translationKey = hasSimilarJobs
    ? "unavailable_job_with_similar"
    : "unavailable_job";

  return (
    <div
      role="status"
      style={{
        minHeight: hasSimilarJobs ? "52vh" : "70vh",
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 16px",
      }}
    >
      <AppText.BodyText
        center
        use="h1"
        margins={{ marginBottom: "0px", marginTop: "0px" }}
        fontWeight={500}
        fontSize="1.5rem"
        lineHeight={1.5}
        style={{
          maxWidth: "800px",
          whiteSpace: "pre-line",
        }}
      >
        {t(translationKey, {
          role: profession,
          healthcareWorkplace: healthcareWorkplaceName,
        })}
      </AppText.BodyText>
    </div>
  );
}
